'use client';

import { useDonationBenefitToast } from '@/app/donation/_hooks/useDonationBenefitToast';
import { DONATION_ROUTES } from '@/constants';

export const HometownDonationBenefitToast = () => {
  const { toastDonationBenefit } = useDonationBenefitToast();
  toastDonationBenefit({
    theme: 'black',
    href: DONATION_ROUTES.HOME.withSearchParams({
      eventParams: {
        utm_source: 'wello',
        utm_medium: 'seo',
        utm_campaign: 'donation',
        utm_content: 'google_250819',
      },
    }),
  });

  return null;
};
